export default "__VITE_PUBLIC_ASSET__97af9858__"